import React, { Component } from 'react';
import { usePromiseTracker } from "react-promise-tracker";
//import ScaleLoader from "react-spinners/ClipLoader";

import classes from "./PromiseSpinner.module.scss"

export const LoadingSpinnerComponent = (props) => {
const { promiseInProgress } = usePromiseTracker();

  return (
    <div>
    {
           (promiseInProgress === true) ?
           <div className={classes.loadWrapper}>
             <div className={classes.loaderLabel}>Loading </div>
             <div className={classes.loader}>Loading...</div>
           </div>
      :
        null
    }
  </div>
  )
};
